import { render, staticRenderFns } from "./Catagory.vue?vue&type=template&id=a958ae0a&scoped=true&"
import script from "./Catagory.vue?vue&type=script&lang=js&"
export * from "./Catagory.vue?vue&type=script&lang=js&"
import style0 from "./Catagory.vue?vue&type=style&index=0&id=a958ae0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a958ae0a",
  null
  
)

export default component.exports